import type { HeatmapScale } from './conditionalFormat'

/** Ratings table — values only; rank columns are plain text. */
export const RATINGS_HEATMAP_COLUMNS = [
  'Current',
  'Pyth',
  '2026 Rating',
  'PS Rating',
  'PS Weight',
  'Total',
  'SOS',
  'rSOS',
] as const

export const RATINGS_COLUMN_SCALES: Record<(typeof RATINGS_HEATMAP_COLUMNS)[number], HeatmapScale> = {
  Current: 'strength',
  Pyth: 'strength',
  '2026 Rating': 'strength',
  'PS Rating': 'strength',
  'PS Weight': 'strength',
  Total: 'magnitude',
  SOS: 'strength',
  rSOS: 'strength',
}

/** Standings — strength for Rating; sequential for outcome probabilities (not good/bad). */
export const STANDINGS_HEATMAP_COLUMNS = [
  'Rating',
  'Most Regular Season Wins %',
  'Fewest Regular Season Wins %',
  'Playoff %',
  'Division %',
  'Pennant %',
  'WS %',
] as const

export const STANDINGS_COLUMN_SCALES: Record<(typeof STANDINGS_HEATMAP_COLUMNS)[number], HeatmapScale> = {
  Rating: 'strength',
  'Most Regular Season Wins %': 'sequential',
  'Fewest Regular Season Wins %': 'sequential',
  'Playoff %': 'sequential',
  'Division %': 'sequential',
  'Pennant %': 'sequential',
  'WS %': 'sequential',
}

/** Matchups — strength for ratings; sequential for win probs. */
export const MATCHUP_HEATMAP_COLUMNS = [
  'awayRating',
  'homeRating',
  'awayProb',
  'homeProb',
  'favoriteProb',
] as const

export const MATCHUP_COLUMN_SCALES: Record<(typeof MATCHUP_HEATMAP_COLUMNS)[number], HeatmapScale> = {
  awayRating: 'strength',
  homeRating: 'strength',
  awayProb: 'sequential',
  homeProb: 'sequential',
  favoriteProb: 'sequential',
}

export function scaleForColumn(
  columnKey: string,
  scales: Record<string, HeatmapScale>,
): HeatmapScale {
  return scales[columnKey] ?? 'strength'
}
